import React from "react";
import StyledH1Heading from "../../common/components/styledH1Heading/StyledH1Heading.tsx";
import StyledLgText from "../../common/components/styledLgText/StyledLgText.tsx";
import Button from "../button/Button.tsx";
import { NavLink } from "react-router-dom";

const ChatBox = () => {
  return (
    <div className="w-full flex py-16 items-center justify-center px-4">
      <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl flex lg:flex-row flex-col w-[95%] max-w-[1280px] py-12 px-8 lg:px-14 justify-around items-center gap-8 shadow-soft">
        <div className="lg:w-[55%] flex flex-col justify-start items-start gap-5">
          <StyledH1Heading
            fontColor={"text-lightBlack"}
            content={"Chat about what's on your mind for"}
            customColor={"text-blue"}
            diffText={"professional success"}
          />
          <StyledLgText
            children={
              "Unlock the power of AI technology to revolutionize your software development process and decision-making."
            }
            fontColor={"text-gray-500"}
          />
          <div className="flex gap-3 mt-2">
            <NavLink to={"/chats"}>
              <Button
                children={"Get Started"}
                className="!w-auto !px-7"
                disabled={false}
              />
            </NavLink>
            <NavLink to={"/pricing"}>
              <Button variant="secondary" children={"View Plans"} className="!w-auto !px-7" />
            </NavLink>
          </div>
        </div>
        <img src="/assets/images/ChatRobo.png" alt="robo" className="w-[80%] lg:w-[35%]" />
      </div>
    </div>
  );
};

export default ChatBox;
